const wrapperConfig = {
  'coin:kaddex.kdx': { },
  'coin:n_b742b4e9c600892af545afb408326e82a6c0c6ed.zUSD': { },
  'coin:free.crankk01': { }
};

export const isWrapperBoosted = (token0, token1) => {
  return false;
};

export default wrapperConfig;